export default function ExternalLinkIcon() {
    return (
        <svg
            width="100%"
            preserveAspectRatio="xMidYMid meet"
            height="8"
            viewBox="0 0 8 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="ic arrow diagonal right up 8px">
                <path fillRule="evenodd" clipRule="evenodd" d="M4.99116 2.125H1.50005V0.875H7.12505V6.5H5.87505V3.00888L1.94199 6.94194L1.05811 6.05806L4.99116 2.125Z" fill="currentColor"/>
            </g>
        </svg>
    )
}
